import { DurationType, Race } from "api";

export enum StatusRound {
    CREATED = "CREATED",
    IN_PROGRESS = "IN_PROGRESS",
    DONE = "DONE",
}

export const StatusRoundDescription = {
    CREATED: "Não iniciada",
    IN_PROGRESS: "Em andamento",
    DONE: "Finalizada",
};

export interface Round {
    id?: string;
    seasonId: string;
    championshipId: string;
    date: string;
    roundNum?: number;
    trackId: string;
    trackName: string;
    trackCourse: string;
    races?: Race[];
    status: StatusRound;
    durationType?: DurationType;
    duration?: number;
    multiplyPointsBy?: number;
}

export const RoundDefault: Round = {
    id: "",
    seasonId: "",
    championshipId: "",
    date: "",
    roundNum: 0,
    trackId: "",
    trackName: "",
    trackCourse: "",
    races: [],
    status: StatusRound.CREATED,
    duration: 0,
    multiplyPointsBy: 1,
};
